import styled from 'styled-components';
import { spacing } from '../../style/theme';
var SectionItem = styled.div.withConfig({
  displayName: "SectionItem",
  componentId: "sc-1dchfg8-0"
})(["flex:1 0 auto;text-align:", ";@media only screen and (max-width:", "px){width:100%;flex:1 1 100%;text-align:left;margin-bottom:", "px;&:last-child{margin-bottom:0;}}"], function (_ref) {
  var alignRight = _ref.alignRight;
  return alignRight ? 'right' : null;
}, spacing.collapseMenuWidth, spacing.base);
export default SectionItem;